import { Box, Grow, styled } from '@mui/material'
import {
  Message,
  RawImageMessage,
  RawWappMessage,
} from '@weblite/ts-action/message'
import { getWappIcon } from '$logic/wapps/wapps.helper'

const ThumbnailContainer = styled('div')`
  display: flex;
  border-radius: 2px;
  overflow: hidden;
`

const Thumbnail = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

function ImageThumbnail({ src }: { src: string }) {
  return <Thumbnail src={src} alt="image-message-thumbnail" />
}



export function MessagePreviewThumbnail({
  message,
  height = 40,
}: {
  message: Message
  height?: number
}) {
  if (!message || (message.type !== 'IMAGE' ))
    return null

  return (
    <ThumbnailContainer
      sx={{
        width: `${height}px`,
        minWidth: `${height}px`,
        height: `${height}px`,
        backgroundColor: 'white',
      }}
    >
      <ImageThumbnail src={(message as RawImageMessage).attachment.base64} />
    </ThumbnailContainer>
  )
}

